module.exports = { isatty: function () { return false } }